import gql from 'graphql-tag';

const GET_DEMOGRAPHIC_SEGMENTS = gql`
  fragment segment on Segment {
    segmentLabel
    count
    percent
  }

  query getdemographicSegments($params: ReportInput!) {
    demographicSegments(params: $params) {
      age {
        ...segment
      }

      income {
        ...segment
      }

      gender {
        ...segment
      }
    }
  }
`;

export default GET_DEMOGRAPHIC_SEGMENTS;
